import { LOCATION_CHANGE } from 'connected-react-router';
import { Middleware } from 'redux';
import { createMessengerToViewport } from './create-messenger';

export const sendLocationChangeToViewport = (): Middleware => {
  const messenger = createMessengerToViewport();

  return () => next => action => {
    if (window.parent === window && action.type === LOCATION_CHANGE) {
      const { pathname, search } = action.payload.location;
      const url = new URL(pathname + search, window.location.href);
      url.searchParams.append('viewport', 'true');
      messenger.send('admin-location-change', { url: url.toString() });
    }
    return next(action);
  };
};
